import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IGetAccountBalanceResponse {
  status?: boolean;
  message?: string;
  data?: {
    accountId?: number;
    accountNumber?: number;
    ledgerBalance?: number;
    availableBalance?: number;
    withdrawableBalance?: number;
  };
  errors?: IApiResponseError;
}

const initialState: IApiState<IGetAccountBalanceResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const getAccountBalanceAsync = createAsyncThunk(
  'accountBalance/get',
  async (_, { rejectWithValue, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;
      const businessId = localStorage.getItem('businessId');

      const accountNumberFromStorage =
        localStorage.getItem('accountNumber') ?? '';

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      let response;

      if (accountNumberFromStorage) {
        response = await api.post(
          '/account-balance',
          { AccountNumber: accountNumberFromStorage },
          config
        );
      }

      return response?.data ?? null;
    } catch (err) {
      const error = err as AxiosError<IGetAccountBalanceResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const accountBalanceFetch = createSlice({
  name: 'accountBalance/fetch',
  initialState,
  reducers: {
    resetAccountBalance: (state) => {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccountBalanceAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(getAccountBalanceAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IGetAccountBalanceResponse;
      })
      .addCase(getAccountBalanceAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IGetAccountBalanceResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetAccountBalance } = accountBalanceFetch.actions;
export default accountBalanceFetch.reducer;
